<template>
    <v-container
    class="pfcl1618818338" >
        <v-text-field class="pfcl1618818342 pr-3" :value="text" @input="$emit('update:text', $event)" :label="$t('webboxes.styling.button.title')"
             />
    </v-container>
</template>
<script>
export default {
    name: 'ButtonStyling',
    props: { text: String },
    data() {
        return {
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
    }
}
</script>